export const AdPerformance = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" fill="none">
    <path
      fill="#F470BD"
      d="M24.69 27.975h79.81V104c0 4.415-3.585 8-8 8H32.69c-4.416 0-8-3.585-8-8V27.975Z"
    />
    <path
      fill="#fff"
      d="M90.075 83.692h-51.25v3h51.25v-3ZM85.32 92.813H42.751v3h42.57v-3ZM78.746 43.835A28.58 28.58 0 0 0 64.45 40a28.578 28.578 0 0 0-14.297 3.835C41.337 48.936 35.86 58.422 35.86 68.59v3.53h57.182v-3.53c0-10.168-5.477-19.655-14.294-24.756Z"
    />
    <path
      fill="#392BA7"
      d="M74.768 68.891h14.745c0-9.275-5.043-17.368-12.533-21.702l-7.374 12.773c3.083 1.785 5.162 5.11 5.162 8.929Z"
    />
    <path
      fill="#B5A7F4"
      d="M39.389 68.891h14.744c0-3.818 2.08-7.144 5.162-8.929L51.921 47.19c-7.49 4.334-12.532 12.426-12.532 21.702Z"
    />
    <path
      fill="#6E56E6"
      d="M69.605 59.962 76.98 47.19a24.937 24.937 0 0 0-12.53-3.36 24.933 24.933 0 0 0-12.529 3.36l7.374 12.773a10.257 10.257 0 0 1 10.31 0Z"
    />
    <path
      fill="#EE399E"
      d="M65.323 69.578a2.712 2.712 0 1 0 0-5.424 2.712 2.712 0 0 0 0 5.424Z"
    />
    <path
      fill="#EE399E"
      d="M66.587 69.265a2.712 2.712 0 0 1-2.528-4.798c.898-.473 11.192-4.489 17.736-7.029.74-.287 1.275.727.62 1.175-5.797 3.96-14.93 10.18-15.829 10.652Z"
    />
    <path
      fill="#0D3880"
      d="M32.708 16h63.773a8.023 8.023 0 0 1 8.019 8.019v3.966H24.69v-3.966A8.023 8.023 0 0 1 32.707 16Z"
    />
    <path
      fill="#fff"
      d="M33.084 24.044a1.802 1.802 0 1 0 0-3.604 1.802 1.802 0 0 0 0 3.604ZM39.198 24.044a1.802 1.802 0 1 0 0-3.604 1.802 1.802 0 0 0 0 3.604ZM45.27 24.044a1.802 1.802 0 1 0 0-3.604 1.802 1.802 0 0 0 0 3.604Z"
    />
  </svg>
);
